"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locales = exports.LocaleProvider = void 0;
/*
 * Copyright '2021' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
const local_storage_store_1 = require("./local-storage/local-storage.store");
const lwp_cookie_store_1 = require("./lwp-cookie/lwp-cookie.store");
const url_locale_source_1 = require("./url/url-locale-source");
class LocaleProvider {
    constructor() {
        this.localStorageStore = new local_storage_store_1.LocalStorageStore();
        this.lwpCookieStore = new lwp_cookie_store_1.LwpCookieStore();
        this.urlSource = new url_locale_source_1.UrlLocaleSource();
    }
    static getInstance() {
        if (!LocaleProvider.instance) {
            LocaleProvider.instance = new LocaleProvider();
        }
        return LocaleProvider.instance;
    }
    getFromUrl() {
        return this.urlSource.getLocale();
    }
    getFromLocalStorage() {
        return this.localStorageStore.getLocale();
    }
    getFromCookie() {
        return this.lwpCookieStore.getLocale();
    }
}
exports.LocaleProvider = LocaleProvider;
exports.Locales = LocaleProvider.getInstance();
//# sourceMappingURL=locale-provider.js.map